import React, { FC } from 'react'
import styles from 'styles/components/card.module.scss'
import { OrderType } from 'types/checkout'
import { UserType } from 'types/user'
import {
  Card,
  CardInner,
  PrintOrderHeader,
  PrintOrderBody,
  PrintOrderTotalQuantity,
  PrintOrderShoppingBags,
  PrintOrderRequest,
  PrintOrderAmount,
  PrintOrderPickupTime,
} from 'components/Card'
import { HorizontalLine, Spacer } from 'components/Utility'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { getShoppingBags } from 'reducks/store/selectors'
import { Caution } from 'components/Typography'

type Props = {
  basketNumber: string
  orders: OrderType[]
  orderTimes: number
  user?: UserType
}

const PrintOrderCard: FC<Props> = (props) => {
  const { basketNumber, orders, orderTimes, user } = props
  const storeShoppingBags = useSelector((state: State) => getShoppingBags(state))

  return (
    <Card isOutlined={true}>
      <CardInner>
        <PrintOrderHeader
          basketNumber={basketNumber}
          orderTimes={orderTimes}
          tel={user ? user.tel : ''}
          username={user ? user.name : ''}
        />
        {orders.length > 1 && (
          <>
            <Spacer size={4} />
            <Caution
              caution={'※複数の注文が入っています。お客さまが同時に取りに来る可能性があります。'}
              size={'medium'}
            />
            <Spacer size={4} />
          </>
        )}
        {orders.map((order, index) => {
          if (order.status === 'canceled') return
          return (
            <React.Fragment key={order.checkout_id}>
              {index !== 0 && <HorizontalLine color={'black'} verticalMargin={16} />}
              <PrintOrderPickupTime order={order} />
              <PrintOrderBody order={order} />
              <HorizontalLine color={'grey04'} verticalMargin={8} />
              <PrintOrderTotalQuantity items={order.items} />
              <PrintOrderAmount amount={order.amount} />
              {(storeShoppingBags.length > 0 || order.shopping_bags.length > 0 || order.request?.length > 0) && (
                <>
                  <Spacer size={4} />
                  <div className={styles.printOrder__footer}>
                    {(storeShoppingBags.length > 0 || order.shopping_bags.length > 0) && (
                      <PrintOrderShoppingBags shoppingBags={order.shopping_bags} />
                    )}
                    {order.request?.length > 0 && (
                      <>
                        <Spacer size={8} />
                        <PrintOrderRequest request={order.request ?? ''} />
                      </>
                    )}
                  </div>
                </>
              )}
            </React.Fragment>
          )
        })}
      </CardInner>
    </Card>
  )
}

export default PrintOrderCard
